// defines all the interests that can be displayed including subcategories
// p = picture
// t = title
// s = selected

module.exports = [
  {
    p: "night_life",
    t: "Nightlife",
    subCategories: [
      // {
      //   p: "", // pic
      //   t: "", // text
      //   s: false, // selected
      // },
      
      { p: "bar", t: "Bars", s: false, },
      { p: "parties", t: "Parties", s: false, },
      { p: "night_clubs", t: "Night Clubs", s: false, },
      { p: "concerts_live_shows", t: "Concerts/Live Shows", s: false, },
      { p: "raves", t: "Raves", s: false, },
      { p: "stand_up_comedy", t: "Stand Up Comedy", s: false, },
      { p: "dance", t: "Dancing", s: false, },
    ]
  },
  
  {
    p: "performing_arts",
    t: "Performing Arts",
    subCategories: [
    ]
  },
  
  {
    p: "sports",
    t: "Sports",
    subCategories: [
      { p: "rockclimbing", t: "Rockclimbing", s: false, },
      { p: "skiing_snowboarding", t: "Ski/Snowboarding", s: false, },
      { p: "soccer", t: "Soccer", s: false, },
      { p: "tennis", t: "Tennis", s: false, },
      { p: "basketball", t: "Basketball", s: false, },
      { p: "cycling", t: "Cycling", s: false, },
      { p: "martial_arts", t: "Martial Arts", s: false, },
      { p: "bowling", t: "Bowling", s: false, },
      { p: "table_tennis", t: "Table Tennis", s: false, },
      { p: "motorbiking", t: "Motorbiking", s: false, },
      { p: "american_football", t: "American Football", s: false, },
      { p: "baseball", t: "Baseball", s: false, },
      { p: "golf", t: "Golf", s: false, },
      { p: "volleyball", t: "Volleyball", s: false, },
      { p: "running", t: "Running", s: false, },
      { p: "boxing", t: "Boxing", s: false, },
      { p: "hockey", t: "Hockey", s: false, },
      { p: "weight_lifting", t: "Weight Lifting", s: false, },
      { p: "dance", t: "Dance", s: false, },
      { p: "pool", t: "Pool", s: false, },
      { p: "darts", t: "Darts", s: false, },
      { p: "skydiving", t: "Skydiving", s: false, },
      { p: "bungee_jumping", t: "Bungee Jumping", s: false, },
      { p: "paragliding", t: "Paragliding", s: false, },
      { p: "archery", t: "Archery", s: false, },
      { p: "ultimate_frisbee", t: "Ultimate Frisbee", s: false, },
      { p: "poker", t: "Poker", s: false, },
    ]
  },
  
  {
    p: "the_outdoors",
    t: "The Outdoors",
    subCategories: [
      { p: "hiking", t: "Hiking", s: false, },
      { p: "camping", t: "Camping", s: false, },
      { p: "fishing", t: "Fishing", s: false, },
      { p: "mountain_biking", t: "Mountain Biking", s: false, },
      { p: "gardening", t: "Gardening", s: false, },
      { p: "rockclimbing", t: "Rockclimbing", s: false, },
      { p: "swimming", t: "Swimming", s: false, },
      { p: "running", t: "Running", s: false, },
      { p: "photography", t: "Photography", s: false, },
      { p: "hunting", t: "Hunting", s: false, },
      { p: "skiing_snowboarding", t: "Ski/Snowboarding", s: false, },
      { p: "yoga", t: "Yoga", s: false, },
      { p: "caving", t: "Caving", s: false, },
      { p: "horseback_riding", t: "Horseback Riding", s: false, },
      { p: "motorbiking", t: "Motorbiking", s: false, },
      { p: "paintball", t: "Paintball", s: false, },
      { p: "rollerskating", t: "Rollerskating", s: false, },
      { p: "ice_skating", t: "Ice Skating", s: false, },
    ]
  },
  
  {
    p: "water_adventures",
    t: "Water Adventures",
    subCategories: [
      { p: "snorkeling", t: "Snorkeling", s: false, },
      { p: "surfing", t: "Surfing", s: false, },
      { p: "paddleboarding", t: "Paddleboarding", s: false, },
      { p: "kayaking", t: "Kayaking", s: false, },
      { p: "swimming", t: "Swimming", s: false, },
      { p: "scuba_diving", t: "Scuba Diving", s: false, },
      { p: "cliff_jumping", t: "Cliff Jumping", s: false, },
      { p: "jet_skiing", t: "Jet Skiing", s: false, },
      { p: "fishing", t: "Fishing", s: false, },
      { p: "water_skiing", t: "Water Skiing", s: false, },
      { p: "sailing", t: "Sailing", s: false, },
      { p: "rafting", t: "Rafting", s: false, },
      { p: "kitesurfing", t: "Kitesurfing", s: false, },
      { p: "canoeing", t: "Canoeing", s: false, },
      { p: "underwater_photography", t: "Underwater Photography", s: false, },
      { p: "rowing", t: "Rowing", s: false, },
      { p: "windsurfing", t: "Windsurfing", s: false, },
      { p: "cave_diving", t: "Cave Diving", s: false, },
      { p: "spearfishing", t: "Spearfishing", s: false, },
    ]
  },
  
]